<template>
  <v-dialog v-model="dialog" persistent max-width="490">
    <v-card class="px-2 py-2">
      <div class="d-flex align-center">
        <p class="text-left color-darkGray px-4 py-6" style="font-size: 18px">
          Atenção: REAGENDAR significa que faz um CANCELAMENTO para depois agendar novamente. Ao
          cancelar uma consulta com a forma de pagamento &#39;&#39;Débito Direto (SEPA)&#39;&#39; o
          seu valor será devolvido em até 5 dias úteis. No entretanto uma percentagem de 0.8% do
          valor da consulta mais 0.25 cêntimos será absorvida pela Stripe antes do retorno.
        </p>
      </div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="ok"> Ok </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    ok() {
      this.dialog = false;
      this.$emit('ok');
    },
  },
};
</script>
